import { AfterViewChecked, Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'app-redirect-endpoint',
  templateUrl: './redirect-endpoint.component.html'
})
export class RedirectEndpointComponent implements AfterViewChecked{
  private readonly oauthService = inject(OAuthService);
  private readonly router = inject(Router);

  wasNotCalled = true;

  ngAfterViewChecked(): void {
    if (this.oauthService.getIdToken() && this.oauthService.getAccessToken() && this.wasNotCalled) {

      this.wasNotCalled = false;
      this.router.navigateByUrl('/');
    }
  }
}
